import { Card } from '@/ui/components/ui/card';
import { cn } from '@/ui/lib/utils';
import type { Feature } from '../types/feature.types';
import { VoteButton } from './vote-button';

interface FeatureCardProps {
	feature: Feature;
	isPopping: boolean;
	isNew: boolean;
	onVote: (id: string) => void;
	onRef: (el: HTMLDivElement | null) => void;
}

export function FeatureCard({
	feature,
	isPopping,
	isNew,
	onVote,
	onRef,
}: FeatureCardProps) {
	const isVoted = feature.isVoted;
	return (
		<Card
			ref={onRef}
			style={{ opacity: isNew ? 0 : 1 }}
			className={cn(
				'flex-row items-start gap-4 p-4 py-4 rounded-2xl border-none will-change-transform transition-[background,box-shadow] duration-300',
				isVoted
					? 'bg-secondary shadow-ionos-card-voted'
					: 'bg-card shadow-ionos-card',
			)}
		>
			<VoteButton
				votes={feature.votes}
				isVoted={isVoted}
				isPopping={isPopping}
				onVote={() => onVote(feature.id)}
			/>
			<div className='flex-1 min-w-0'>
				<p
					className={cn(
						'text-[15px] font-semibold text-foreground leading-[1.4]',
						feature.description && 'mb-1',
					)}
				>
					{feature.title}
				</p>
				{feature.description && (
					<p className='text-[13px] text-muted-foreground leading-relaxed'>
						{feature.description}
					</p>
				)}
			</div>
		</Card>
	);
}
